var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('Alert'),(_vm.loader)?_c('Loader'):_vm._e(),_c('router-view'),(_vm.test)?_c('v-alert',{staticClass:"test-environment-badge",attrs:{"type":"info","color":"#FF8F1C","dark":"","dense":"","elevation":"2"}},[_c('span',[_vm._v("Ambiente de pruebas")])]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }